import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=a8ef61ce"
import script from "./callback.vue?vue&type=script&lang=js"
export * from "./callback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports